import { AppController } from "./AppController";
var AppRootComponent = /** @class */ (function () {
    function AppRootComponent(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(AppRootComponent.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    return AppRootComponent;
}());
export { AppRootComponent };
